<template>
    <div class="groupShopSuccessPage">
       <mu-appbar class="head">
        <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>        
         <p class="title">超多果干和坚果的雪花酥</p>
        <mu-icon-menu icon=":fa fa-more" slot="right">
            <mu-menu-item to="/usercenter/index" title="个人中心"/>
            <mu-menu-item to="/" title="首页"/>
            <mu-menu-item to="/retail/cart" title="购物车"/>
          </mu-icon-menu>
        </mu-appbar>
        <div style="background: #fff;">
          <mu-list-item class="invite_product">
            <div class="product_item" >
                <router-link to="">
                  <img src="http://imgserver.xurigo.com/upload/images/temp/2018/06/01/151838bafd590e-a86f-49a6-8aca-9110e5cb612a.jpg" class="proImg" alt=""> 
                  <div class="product_info" :style="{width: proItemInfoWidth +'px'}">
                      <div class="product_title">
                          <span class="slaePrice">3.7折</span>
                          <span class="prime_cost">指导价69元</span>
                          超多果干和坚果的雪花酥
                      </div>
                      <div class="sign">
                        <div class="shopNum sign">3人团</div>
                        <div class="free_post sign">包邮</div>
                      </div> 
                      
                      <div class="price_time">
                          <p class="price">拼团价<span>25</span>元</p>
                          <p class="sellCount">已团2566件</p>
                      </div>
                  </div>       
                </router-link>  
            </div>
        </mu-list-item>
        <div class="invite">
          <p class="inviteCount">拼单完成 ，成团成功</p>
          <div class="inviteImg">
            <div class="clonel">
              <img src="\static\shangquan\其他.png" alt="">
              <p class="tuanzhang">团长</p>
            </div>
            <mu-avatar src="http://imgserver.xurigo.com/upload/images/temp/2018/06/01/151838bafd590e-a86f-49a6-8aca-9110e5cb612a.jpg" slot="leftAvatar"/>
            <mu-avatar src="http://imgserver.xurigo.com/upload/images/temp/2018/06/01/151838bafd590e-a86f-49a6-8aca-9110e5cb612a.jpg" slot="leftAvatar"/>
          </div>
        </div>
        <mu-raised-button label="点击邀请好友拼单" class="demo-raised-button invite_botton" disabled/>
        <div class="inviteTime">23:59:59后失效</div>
        <div class="orderStep">
            <img src="/static/orderStep.png" alt="">
        </div>
        <!-- <div class="orderStep">
            <p class="step_num">1</p><span class="stepOne">选择商品</span>
            <span>▪▪▪▪▪</span>
            <p class="step_num">2</p><span class="stepOne">选择商品</span>
            <span>▪▪▪▪▪</span>
            <p class="step_num">3</p><span class="stepOne">选择商品</span>
            <span>▪▪▪▪▪</span>
            <p class="step_num">4</p><span class="stepOne">选择商品</span>
        </div> -->
       </div>
        <mu-list>
          <div class="list_item">
              <div class="itemTop">
                <div class="itemTitle">
                  <p class="activeName">更多拼团</p> 
                  <p class="time">距离结束 <span>60:39:25</span> </p>
                </div>
                <div class="topRight">
                  <p class="peopleCount">51256人正在拼</p>
                    <mu-avatar src="\static\shangquan\其他.png" class="zindexOne" slot="leftAvatar"/>
                    <mu-avatar src="\static\shangquan\其他.png" class="zindexTwo" slot="leftAvatar"/>
                    <mu-avatar src="\static\shangquan\其他.png" class="zindexThree" slot="leftAvatar"/>                 
                </div>
              </div>
              <mu-list-item class="product">
                  <div class="product_item" >
                     <router-link to="">
                        <img src="http://imgserver.xurigo.com/upload/images/temp/2018/06/01/151838bafd590e-a86f-49a6-8aca-9110e5cb612a.jpg" class="proImg" alt=""> 
                        <div class="product_info" :style="{width: proItemInfoWidth +'px'}">
                            <div class="product_title">
                                <span class="slaePrice">3.7折</span>
                                <span class="prime_cost">指导价69元</span>
                                超多果干和坚果的雪花酥
                            </div>
                            <div class="sign">
                              <div class="shopNum sign">3人团</div>
                              <div class="free_post sign">包邮</div>
                            </div> 
                            <div class="price_time">
                                <p class="price">拼团价<span>25</span>元</p>
                                <p class="sellCount">已团2566件</p>
                            </div>
                            <div class="num_goshop">         
                                <mu-raised-button label="去拼团" class="demo-raised-button"/>
                            </div>
                        </div>                     
                     </router-link>  
                  </div>
              </mu-list-item>
              <mu-list-item class="product">
                  <div class="product_item" >
                     <router-link to="">
                        <img src="http://imgserver.xurigo.com/upload/images/temp/2018/06/01/151838bafd590e-a86f-49a6-8aca-9110e5cb612a.jpg" class="proImg" alt=""> 
                        <div class="product_info" :style="{width: proItemInfoWidth +'px'}">
                            <div class="product_title">
                                <span class="slaePrice">3.7折</span>
                                <span class="prime_cost">指导价69元</span>
                                超多果干和坚果的雪花酥
                            </div>
                            <div class="sign">
                              <div class="shopNum sign">3人团</div>
                              <div class="free_post sign">包邮</div>
                            </div> 
                            <div class="price_time">
                                <p class="price">拼团价<span>25</span>元</p>
                                <p class="sellCount">已团2566件</p>
                            </div>
                            <div class="num_goshop">         
                                <mu-raised-button label="去拼团" class="demo-raised-button"/>
                            </div>
                        </div>    
                        
                     </router-link>  
                  </div>
              </mu-list-item>
              <mu-list-item class="product">
                  <div class="product_item" >
                     <router-link to="">
                        <img src="http://imgserver.xurigo.com/upload/images/temp/2018/06/01/151838bafd590e-a86f-49a6-8aca-9110e5cb612a.jpg" class="proImg" alt=""> 
                        <div class="product_info" :style="{width: proItemInfoWidth +'px'}">
                            <div class="product_title">
                                <span class="slaePrice">3.7折</span>
                                <span class="prime_cost">指导价69元</span>
                                超多果干和坚果的雪花酥
                            </div>
                            <div class="sign">
                              <div class="shopNum sign">3人团</div>
                              <div class="free_post sign">包邮</div>
                            </div> 
                            
                            <div class="price_time">
                                <p class="price">拼团价<span>25</span>元</p>
                                <p class="sellCount">已团2566件</p>
                            </div>
                            <div class="num_goshop">         
                                <mu-raised-button label="去拼团" class="demo-raised-button"/>
                            </div>
                        </div>    
                        
                     </router-link>  
                  </div>
              </mu-list-item>
          </div>
          <div class="list_item">
              <div class="itemTop">
                <div class="itemTitle">
                  <p class="activeName">更多拼团</p> 
                  <p class="time">距离结束 <span>60:39:25</span> </p>
                </div>
                <div class="topRight">
                  <p class="peopleCount">51256人正在拼</p>
                    <mu-avatar src="\static\shangquan\其他.png" class="zindexOne" slot="leftAvatar"/>
                    <mu-avatar src="\static\shangquan\其他.png" class="zindexTwo" slot="leftAvatar"/>
                    <mu-avatar src="\static\shangquan\其他.png" class="zindexThree" slot="leftAvatar"/>                 
                </div>
              </div>
              <mu-list-item class="product">
                  <div class="product_item" >
                     <router-link to="">
                        <img src="http://imgserver.xurigo.com/upload/images/temp/2018/06/01/151838bafd590e-a86f-49a6-8aca-9110e5cb612a.jpg" class="proImg" alt=""> 
                        <div class="product_info" :style="{width: proItemInfoWidth +'px'}">
                            <div class="product_title">
                                <span class="slaePrice">3.7折</span>
                                <span class="prime_cost">指导价69元</span>
                                超多果干和坚果的雪花酥
                            </div>
                            <div class="sign">
                              <div class="shopNum sign">3人团</div>
                              <div class="free_post sign">包邮</div>
                            </div> 
                            <div class="price_time">
                                <p class="price">拼团价<span>25</span>元</p>
                                <p class="sellCount">已团2566件</p>
                            </div>
                            <div class="num_goshop">         
                                <mu-raised-button label="去拼团" class="demo-raised-button"/>
                            </div>
                        </div>                     
                     </router-link>  
                  </div>
              </mu-list-item>
              <mu-list-item class="product">
                  <div class="product_item" >
                     <router-link to="">
                        <img src="http://imgserver.xurigo.com/upload/images/temp/2018/06/01/151838bafd590e-a86f-49a6-8aca-9110e5cb612a.jpg" class="proImg" alt=""> 
                        <div class="product_info" :style="{width: proItemInfoWidth +'px'}">
                            <div class="product_title">
                                <span class="slaePrice">3.7折</span>
                                <span class="prime_cost">指导价69元</span>
                                超多果干和坚果的雪花酥
                            </div>
                            <div class="sign">
                              <div class="shopNum sign">3人团</div>
                              <div class="free_post sign">包邮</div>
                            </div> 
                            <div class="price_time">
                                <p class="price">拼团价<span>25</span>元</p>
                                <p class="sellCount">已团2566件</p>
                            </div>
                            <div class="num_goshop">         
                                <mu-raised-button label="去拼团" class="demo-raised-button"/>
                            </div>
                        </div>    
                        
                     </router-link>  
                  </div>
              </mu-list-item>
              <mu-list-item class="product">
                  <div class="product_item" >
                     <router-link to="">
                        <img src="http://imgserver.xurigo.com/upload/images/temp/2018/06/01/151838bafd590e-a86f-49a6-8aca-9110e5cb612a.jpg" class="proImg" alt=""> 
                        <div class="product_info" :style="{width: proItemInfoWidth +'px'}">
                            <div class="product_title">
                                <span class="slaePrice">3.7折</span>
                                <span class="prime_cost">指导价69元</span>
                                超多果干和坚果的雪花酥
                            </div>
                            <div class="sign">
                              <div class="shopNum sign">3人团</div>
                              <div class="free_post sign">包邮</div>
                            </div> 
                            
                            <div class="price_time">
                                <p class="price">拼团价<span>25</span>元</p>
                                <p class="sellCount">已团2566件</p>
                            </div>
                            <div class="num_goshop">         
                                <mu-raised-button label="去拼团" class="demo-raised-button"/>
                            </div>
                        </div>    
                        
                     </router-link>  
                  </div>
              </mu-list-item>
          </div>
        </mu-list>
    </div>
</template>
<script>
import siteconfig from '../../util/siteconfigCache'
export default {
  data() {
    return {
       proItemInfoWidth: (parseInt(document.documentElement.clientWidth)-137),
    }
  },
  mounted() {

  },
  methods: {  
    GoHistory(){
      this.$router.goBack()
    },
  }
};
</script>
<style>
  .groupShopSuccessPage{
  }
  .groupShopSuccessPage .head .title{
    font-size: 16px;
  }
  .groupShopSuccessPage .invite_product{
    border-bottom: 1px solid #f5f5f5
  }
  .groupShopSuccessPage  .invite_product .product_item .proImg{
    width: 95px;
    float: left;
    background: white;
    height: 95px;
  }
  .groupShopSuccessPage  .invite_product .product_item .product_info{
    float: right;
    margin-left: 10px;
  }
  .groupShopSuccessPage  .invite_product .product_item .product_info .product_title{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 14px;
    color: #000;
  }
  .groupShopSuccessPage  .invite_product .product_item .product_info .product_title .slaePrice{
    color: red;
    font-weight: bold;
  }
  .groupShopSuccessPage  .invite_product .product_item .product_info .product_title .prime_cost{
    color: #666;
  }
  .groupShopSuccessPage  .invite_product .product_item .product_info .sign{
    text-align: center;
    border-radius: 2px;
    color: #fff;
    font-size: 12px;
    padding: 1px 0;
    overflow: hidden;
  }
  .groupShopSuccessPage  .invite_product .product_item .product_info .sign .shopNum{
    background: #EB4D54;
    width: 50px;
    border-radius: 5px;
    margin-right: 10px;
    float: left;
  }
  .groupShopSuccessPage  .invite_product .product_item .product_info .sign .free_post{
    float: left;
    width: 50px;
    border-radius: 5px;
    margin-right: 10px;
    background: #CC9137;
  }
  .groupShopSuccessPage  .invite_product .product_item .product_info .price_time{
    float: left;
  }
  .groupShopSuccessPage  .invite_product .product_item .product_info .num_goshop{
    float: right;
  }
  .groupShopSuccessPage  .invite_product .product_item .product_info .price_time .price{
    color: #C13B38;
    font-size: 14px;
    line-height: 20px;
    height: 20px;
    margin-top: 11px;
  }
  .groupShopSuccessPage  .invite_product .product_item .product_info .price_time .price span{
    font-size: 20px;
    padding: 0 5px;
  }
  .groupShopSuccessPage  .invite_product .product_item .product_info .price_time .sellCount{
    font-size: 14px;
    color: #999;
    text-align: left;
  }
  .groupShopSuccessPage  .invite_product .product_item .product_info .num_goshop .mu-raised-button{
    min-width: 60px;
    height: 25px;
    margin-top: 13px;
    background: #C13B38;
    color: #fff;
  }
  .groupShopSuccessPage .invite{
    padding: 0 16px;
    margin-top: 25px;
  }
  .groupShopSuccessPage .invite .inviteCount{
    text-align: center;
    font-size: 16px;
  }
  .groupShopSuccessPage .invite .inviteImg{
    text-align: center;
    margin-top: 10px;
  }
  .groupShopSuccessPage .invite .inviteImg .clonel{
    width: 44px;
    height: 44px;
    border: 1px solid #FAC424;
    position: relative;
    display: inline-block;
    text-align: center;
    margin-right: 4px;
    border-radius: 50%;
  }
  .groupShopSuccessPage .invite .inviteImg .mu-avatar{
    width: 40px;
    height: 40px;
    margin-right: 5px;
  }
  .groupShopSuccessPage .invite .inviteImg .clonel img{
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
  .groupShopSuccessPage .invite .inviteImg .fa-mycicle1{
    text-align: left;
    padding-top: 3px;
    color: #999;
  }
  .groupShopSuccessPage .invite .inviteImg .tuanzhang{
    position: absolute;
    left: -5px;
    top: -5px;
    color: #CA8F10;
    background: #FAC424;
    border-radius: 10px 10px;
    padding: 0 3px;
    font-size: 12px;
  }
  .groupShopSuccessPage .invite_botton{
    width: 100%;
    height: 45px;
    margin-top: 25px;
  }
  .groupShopSuccessPage .invite_botton .mu-raised-button-label{
    font-size: 16px;
  }
  .groupShopSuccessPage .inviteTime{
    color: #999;
    font-size: 12px;
    margin-top: 5px;
    text-align: center;
  }
  .groupShopSuccessPage .orderStep{
    padding: 0 16px;
    margin-top: 20px;
    height: 60px;;
    display: flex;
    align-items: center;
    border-top: 1px solid #f5f5f5;
  }
  .groupShopSuccessPage .orderStep img{
    width: 100%;
  }
  /* .groupShopSuccessPage .orderStep .step_num{
    width: 15px;
    height: 15px;
    color: #fff;
    background: #666;
    border-radius: 50%;
    font-size: 12px;
    text-align: center;
    line-height: 15px;
  }
  .groupShopSuccessPage .orderStep .stepOne{
    font-size: 14px;
    padding-left: 3px;
  } */

  .groupShopSuccessPage .mu-list{
    padding: 0;
    margin-top: 15px;
  }
  .groupShopSuccessPage .mu-list .list_item{
    margin-top: 10px;
    padding: 10px 0;
    background: #fff;
  }
  .groupShopSuccessPage .mu-list .list_item:first-child{
    margin: 0;
  }
  .groupShopSuccessPage .mu-list .list_item .itemTop{
    overflow: hidden;
    padding: 0 16px;
  }
  .groupShopSuccessPage .mu-list .list_item .itemTop .itemTitle{
    float: left;
    font-size: 16px;
    width: 40%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 50px;
  }
  .groupShopSuccessPage .mu-list .list_item .itemTop .itemTitle .activeName{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .groupShopSuccessPage .mu-list .list_item .itemTop .itemTitle .time{
    font-size: 12px;
    color: #999;
  }
  .groupShopSuccessPage .mu-list .list_item .itemTop .itemTitle .time span{
    padding-left: 5px;
    color: #DEAAA7;
  }
  .groupShopSuccessPage .mu-list .list_item .itemTop .topRight{
    float: right;
    display: flex;
    align-items: center;
    background: #FEF2F9;
    width: auto;
    padding: 0 5px;
    border-radius: 15px;
    position: relative;
    height: 30px;
    padding-right: 60px;
    margin-top: 5px;
  }
  .groupShopSuccessPage .mu-list .list_item .itemTop .topRight .peopleCount{
    font-size: 14px;
    color: red;
    padding-right: 5px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 100px;
  }
  .groupShopSuccessPage .mu-list .list_item .itemTop .topRight .mu-avatar{
    width: 23px;
    height: 23px;
    position: absolute;
    background: #fff;
    border-radius: 50%; 
  }
  .groupShopSuccessPage .mu-list .list_item .itemTop .topRight .zindexOne{
    right: 5px;
  }
  .groupShopSuccessPage .mu-list .list_item .itemTop .topRight .zindexTwo{
    right: 20px;
  }
  .groupShopSuccessPage .mu-list .list_item .itemTop .topRight .zindexThree{
    right: 35px;
  }
  .groupShopSuccessPage .mu-list .list_item .product .product_item .proImg{
    width: 95px;
    float: left;
    background: white;
    height: 95px;
  }
  .groupShopSuccessPage .mu-list .list_item .product .product_item .product_info{
    float: right;
    margin-left: 10px;
  }
  .groupShopSuccessPage .mu-list .list_item .product .product_item .product_info .product_title{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 14px;
    color: #000;
  }
  .groupShopSuccessPage .mu-list .list_item .product .product_item .product_info .product_title .slaePrice{
    color: red;
    font-weight: bold;
  }
  .groupShopSuccessPage .mu-list .list_item .product .product_item .product_info .product_title .prime_cost{
    color: #666;
  }
  .groupShopSuccessPage .mu-list .list_item .product .product_item .product_info .sign{
    text-align: center;
    border-radius: 2px;
    color: #fff;
    font-size: 12px;
    padding: 1px 0;
    overflow: hidden;
  }
  .groupShopSuccessPage .mu-list .list_item .product .product_item .product_info .sign .shopNum{
    background: #EB4D54;
    width: 50px;
    border-radius: 5px;
    margin-right: 10px;
    float: left;
  }
  .groupShopSuccessPage .mu-list .list_item .product .product_item .product_info .sign .free_post{
    float: left;
    width: 50px;
    border-radius: 5px;
    margin-right: 10px;
    background: #CC9137;
  }
  .groupShopSuccessPage .mu-list .list_item .product .product_item .product_info .price_time{
    float: left;
  }
  .groupShopSuccessPage .mu-list .list_item .product .product_item .product_info .num_goshop{
    float: right;
  }
  .groupShopSuccessPage .mu-list .list_item .product .product_item .product_info .price_time .price{
    color: #C13B38;
    font-size: 14px;
  }
  .groupShopSuccessPage .mu-list .list_item .product .product_item .product_info .price_time .price span{
    font-size: 20px;
    padding: 0 5px;
  }
  .groupShopSuccessPage .mu-list .list_item .product .product_item .product_info .price_time .sellCount{
    font-size: 14px;
    color: #999;
    text-align: left;
  }
  .groupShopSuccessPage .mu-list .list_item .product .product_item .product_info .num_goshop .mu-raised-button{
    min-width: 60px;
    height: 25px;
    margin-top: 13px;
    background: #C13B38;
    color: #fff;
  }
</style>




// WEBPACK FOOTER //
// src/pages/groupShop/groupShopSuccess.vue